import {format} from 'date-fns/format';
import {isToday} from 'date-fns/isToday';
import {isYesterday} from 'date-fns/isYesterday';
import React, {forwardRef} from 'react';
import {TransactionSchema} from '../../model/TransactionSchema';
import {getOrderResultSign} from '../../model/getOrderResultSign';
import PendingTransactPair from '../PendingTransactPair/PendingTransactPair';
import scss from './PendingTransactItem.module.scss';
import {PENDING_TRANS_IMG} from './constants';

export interface PendingTransactItemProps {
    order: TransactionSchema;
}

const formatDate = (dateString: string) => {
    const date = new Date(dateString);

    const time = format(date, 'HH:mm');
    const fullDate = format(date, 'MMM dd, HH:mm');

    if (isToday(date)) {
        return `Today, ${time}`;
    } else if (isYesterday(date)) {
        return `Yesterday, ${time}`;
    } else {
        return fullDate;
    }
};

export const PendingTransactItem = forwardRef<HTMLDivElement, PendingTransactItemProps>(({order}, ref) => {
    const operationName = getOperationName(order);
    return (
        <div className={scss.container} id={order.id.toString()} ref={ref}>
            <img className={scss.icon} src={getOperationIcon(order)} />
            <div className={scss.operationContainer}>
                <div className={scss.operatAmountContainer}>
                    <div className={scss.transactStr}>
                        <PendingTransactPair
                            sign={getOrderResultSign(order)}
                            currency={order.volume.currency}
                            value={order.volume.value}
                        />
                    </div>
                </div>
                <div className={scss.descContainer}>
                    <span>{operationName}</span>
                    <span>{formatDate(order.created_at)}</span>
                </div>
            </div>
        </div>
    );
});
PendingTransactItem.displayName = 'PendingTransactItem';

function getOperationIcon(order: TransactionSchema): string | undefined {
    return PENDING_TRANS_IMG[getOperationName(order).toUpperCase()];
}

function getOperationName(order: TransactionSchema) {
    const {type_human} = order;
    const localTitle = type_human.toUpperCase();

    switch (localTitle) {
        case 'SEND':
            return 'Send';
        case 'TOKEN SEND':
            return 'Send';

        case 'BUY':
            return 'Buy';
        case 'TOKEN PURCHASE':
            return 'Buy';

        case 'EXCHANGE':
            return 'Exchange';
        case 'REDEMPTION':
            return 'Exchange';
        case 'OTC EXCHANGE':
            return 'Exchange';
        case 'TOKEN SWAP':
            return 'Exchange';

        case 'RECEIVE':
            return 'Receive';
        case 'TOKEN RECEIVE':
            return 'Receive';
        case 'REFUND':
            return 'Receive';

        case 'SELL':
            return 'Sell';
        case 'TOKEN SELL':
            return 'Sell';

        case 'TOP UP':
            return 'Top up';
        case 'TOP UP SEPA':
            return 'Top up';
        case 'TOP UP SWIFT':
            return 'Top up';

        case 'WITHDRAW':
            return 'Withdraw';
        case 'FEE':
            return 'Withdraw';

        default:
            return type_human;
    }
}
